const menu = [
  'workout',
  'food_database',
  'articles',
  'tools_h',
  'login_register'
];

export default menu;
